import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Avatar,
  Menu,
  MenuItem,
  Divider,
  Tooltip,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { HiHome, HiLogout, HiUser } from 'react-icons/hi';
import { useAuth } from '@/contexts/AuthContext';
import styles from './AdminV2Header.module.scss';

interface AdminV2HeaderProps {
  title?: string;
}

const AdminV2Header: React.FC<AdminV2HeaderProps> = ({ title = 'Administración V2' }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleGoToMainApp = () => {
    navigate('/');
  };

  const handleLogout = async () => {
    const { supabase } = await import('@/utils/supabaseClient');
    await supabase.auth.signOut();
    navigate('/login');
  };

  return (
    <AppBar position="fixed" className={styles.header}>
      <Toolbar className={styles.toolbar}>
        <Box className={styles.headerLeft}>
          <Typography variant="h6" className={styles.headerTitle}>
            {title}
          </Typography>
        </Box>

        <Box className={styles.headerRight}>
          <Tooltip title="Ir a la aplicación principal" placement="bottom" arrow>
            <button
              className={styles.mainAppButton}
              onClick={handleGoToMainApp}
              type="button"
            >
              <HiHome size={18} />
              <span>App Principal</span>
            </button>
          </Tooltip>

          <Box className={styles.userInfo} onClick={handleMenuOpen}>
            <Avatar className={styles.userAvatar}>
              {user?.name?.charAt(0) || user?.email?.charAt(0) || 'U'}
            </Avatar>
            <Box className={styles.userDetails}>
              <Typography variant="body2" className={styles.userName}>
                {user?.name || user?.email || 'Usuario'}
              </Typography>
              <Typography variant="caption" className={styles.userRole}>
                Administrador
              </Typography>
            </Box>
          </Box>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleMenuClose}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <HiUser size={16} />
                <span>Mi Perfil</span>
              </Box>
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleLogout}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <HiLogout size={16} />
                <span>Cerrar Sesión</span>
              </Box>
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default AdminV2Header;
